/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/success_character.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'

export const ApplyForNewAccount: React.FC = observer(() => {
  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character success-character" loading="lazy"/>
  const title = (
    <p className="guide-txt big">
      새로운 계정 생성 완료
    </p>
  )
  const body = (
    <div className="guide-box small ">
      아래 &quot;카카오 로그인하기&quot; 버튼을 누르시고<br/>
      카카오 계정으로 다시 로그인 하시면,<br/>
      계정이관 신청 페이지가 나타납니다.
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
